var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sliderassembly" },
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        _vm._l(_vm.datas, function (items, index) {
          return _c(
            "el-collapse-item",
            { key: index, attrs: { title: items.title, name: index + 1 } },
            _vm._l(items.components, function (item, ind) {
              return _c(
                "div",
                {
                  key: ind,
                  staticClass: "componList",
                  attrs: { draggable: "true", "data-name": item.name },
                  on: {
                    dragstart: function ($event) {
                      return _vm.drag($event)
                    },
                    dragend: function ($event) {
                      return _vm.dragends($event)
                    },
                  },
                },
                [
                  item.icon
                    ? _c("i", { staticClass: "iconfont", class: item.icon })
                    : item.zdyicon
                    ? _c("i", { staticClass: "zdy-icon", class: item.zdyicon })
                    : _c("van-icon", { attrs: { name: item.vanIcon } }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.title))]),
                ],
                1
              )
            }),
            0
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }